import { render, staticRenderFns } from "./PrescriptionsCard.vue?vue&type=template&id=b6384c34&scoped=true&"
import script from "./PrescriptionsCard.vue?vue&type=script&lang=js&"
export * from "./PrescriptionsCard.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionsCard.vue?vue&type=style&index=0&id=b6384c34&prod&scoped=true&lang=css&"
import style1 from "./PrescriptionsCard.vue?vue&type=style&index=1&id=b6384c34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6384c34",
  null
  
)

export default component.exports